import Vue from 'vue';
import { createActionHelpers } from 'vuex-loading';
import { DateTime } from 'luxon';
import _ from 'lodash';
import Service from './service';

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading',
});

export const CLEAR_MODULE = 'CLEAR_MODULE';
export const UPDATE_ERROR = 'UPDATE_ERROR';
export const UPDATE_LOADED = 'UPDATE_LOADED';
export const FORMAT_MODEL = 'FORMAT_MODEL';
export const UPDATE_PLEDGES = 'UPDATE_PLEDGES';
export const UPDATE_DISTRIBUCION_DATA = 'UPDATE_DISTRIBUCION_DATA';
export const UPDATE_NOTARY_DATA = 'UPDATE_NOTARY_DATA';
export const INCREMENT_TOTAL_TASACION = 'UPDATE_TOTAL_TASACION';
export const CLEAR_DISTRIBUTION_DATA = 'CLEAR_DISTRIBUTION_DATA';
export const UPDATE_TABLE_DATA = 'UPDATE_TABLE_DATA';
export const saveNotaryAction = 'saveNotaryAction';
export const initModuleAction = 'initModuleAction';
export const updatePledgesAction = 'updatePledgesAction';
export const getDistributionDataAction = 'getDistributionDataAction';
export const updateStatusFirmadaAction = 'updateStatusFirmadaAction';
export const updateOperationNotary = 'updateOperationNotary';
export const updateDistributionDataAction = 'updateDistributionDataAction';
export const updateOperationNotaryAction = 'updateOperationNotaryAction';
export default {
  namespaced: true,
  state: {
    error: '',
    loading: true,
    notaryData: {},
    distribution: [],
    distributionData: {},
    totalTasacion: 0,
    tableData: [],
  },
  mutations: {
    [CLEAR_MODULE](state) {
      Vue.set(state, 'types', {});
      Vue.set(state, 'loading', true);
      Vue.set(state, 'error', '');
      Vue.set(state, 'notaries', []);
      Vue.set(state, 'pledgesData', []);
      Vue.set(state, 'distributionData', {});
      Vue.set(state, 'tableData', []);
      Vue.set(state, 'totalTasacion', 0);
    },
    [UPDATE_ERROR](state, payload) {
      Vue.set(state, 'error', payload);
    },
    [UPDATE_LOADED](state, payload) {
      Vue.set(state, 'loading', payload);
    },
    [FORMAT_MODEL](state, payload) {
      Vue.set(state, 'notaryData', payload);
    },
    [UPDATE_PLEDGES](state, payload) {
      Vue.set(state, 'pledgesData', payload);
    },
    [UPDATE_NOTARY_DATA](state, payload) {
      Vue.set(state, 'notaryData', payload);
    },
    [UPDATE_DISTRIBUCION_DATA](state, payload) {
      Vue.set(state, 'distributionData', payload);
    },
    [CLEAR_DISTRIBUTION_DATA](state, payload) {
      Vue.set(state, 'distributionData', payload);
    },
    [INCREMENT_TOTAL_TASACION](state, payload) {
      state.totalTasacion += parseFloat(payload);
    },
    [UPDATE_TABLE_DATA](state, payload) {
      state.tableData.push(payload);
    },
  },
  actions: {
    [initModuleAction]({ commit, rootGetters, dispatch }, payload) {
      startLoading(dispatch, 'init formalizacion');
      commit(UPDATE_LOADED, true);
      commit(CLEAR_MODULE);
      if (payload) {
        Service.getData(payload)
          .then((res) => {
            commit(FORMAT_MODEL, res);
            commit(UPDATE_LOADED, false);
            endLoading(dispatch, 'init formalizacion');
          });
      }
    },
    [updatePledgesAction]({ commit, rootGetters, dispatch }, payload) {
      commit(UPDATE_PLEDGES, payload);
      dispatch('getDistributionDataAction', payload);
    },
    [getDistributionDataAction]({ commit, rootGetters, dispatch }, payload) {
      startLoading(dispatch, 'init distribution');
      commit(CLEAR_DISTRIBUTION_DATA, []);
      if (payload.length > 0) {
        payload.forEach((pledge, index) => {
          let totalTasacion = 0;
          if (pledge.id !== 'dummy') {
            Service.getDistributionByPledge(pledge.id)
              .then((res) => {
                if (pledge.appraisals && pledge.appraisals.length > 0) {
                  totalTasacion += pledge.appraisals[0].importeTasacion;
                }
                payload[index].value = res.value;
                payload[index].percentage = res.percentage;
                payload[index].idDistribution = res.idDistribution;
                commit(INCREMENT_TOTAL_TASACION, totalTasacion);
                commit(UPDATE_TABLE_DATA, payload[index]);
                endLoading(dispatch, 'init distribution');
              });
          }
        });
        const arrayToObject = (arr, keyField) =>
        Object.assign({}, ...arr.map(item => ({ [item[keyField]]: item })));
        const object = arrayToObject(payload, 'id');
        commit(UPDATE_DISTRIBUCION_DATA, object);
        endLoading(dispatch, 'init distribution');
      }
    },
    [updateStatusFirmadaAction]({ commit, rootGetters, dispatch }, payload) {
      startLoading(dispatch, 'update firmada');
      const status = rootGetters['taxonomy/searchTaxonomyValue']({ vid: 'status', text: 'Firmada' });
      payload.state = status;
      return dispatch('operation_model/upsertEntityAction', payload, { root: true })
        .then(() => {
          endLoading(dispatch, 'update firmada');
        })
        .catch(() => {
          endLoading(dispatch, 'update firmada');
          dispatch('updateErrorOverlay', 'Ha ocurrido un error al actualizar la operación. Intentelo de nuevo.', { root: true });
        });
    },
    [updateDistributionDataAction]({ commit, rootGetters, dispatch }, payload) {
      startLoading(dispatch, 'update formalizacion');
      payload.models.forEach((model) => {
        if (model.idDistribution && model.idDistribution.length > 0) {
          Service.updateDistributionData(model);
          endLoading(dispatch, 'update formalizacion');
        } else {
          Service.createDistributionData(model)
            .then((res) => {
              Service.updatePledgeRel(model, res.data.data);
              endLoading(dispatch, 'update formalizacion');
            })
            .catch((error) => {
              if (error && error.response) {
                dispatch('updateErrorOverlay', error, { root: true });
                endLoading(dispatch, 'update formalizacion');
              }
            });
        }
        dispatch(getDistributionDataAction, rootGetters['garantia/pledges']);
      });
    },
    async [updateOperationNotaryAction]({ commit, dispatch }, payload) {
      startLoading(dispatch, 'update formalizacion');
      payload.op.notarioOperacion = payload.notaryModel.id;
      // BAD HACK !!!!!!
      if (!_.isNil(payload.notaryModel.fechaFirma)) {
        payload.date.fechaFirmaNotario = DateTime.fromISO(payload.notaryModel.fechaFirma).setLocale('es').toFormat("yyyy-MM-dd'T'HH:mm:ss");
      } else {
        payload.date.fechaFirmaNotario = null;
      }
      try {
        await dispatch('operation_model/upsertEntityAction', payload.op, { root: true });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
      try {
        await dispatch('datesAssignements_model/upsertEntityAction', payload.date, { root: true });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
      endLoading(dispatch, 'update formalizacion');
    },
  },
  getters: {
    loading: state => state.loading,
    notaryData: state => state.notaryData,
    distributionData: state => state.distributionData,
    totalTasacion: state => state.totalTasacion,
    tableData: state => _.uniqBy(state.tableData, 'id'),
  },
};



// WEBPACK FOOTER //
// ./src/features/formalizacion/store.js